<template>
	<div class="modal-feedback-container">
		<button class="close-btn flex justify-end" @click="onClose" />
		<div class="flex flex-col flex-center" style="letter-spacing: 0.98px">
			<h6
				class="text-black text-center mt-10"
				v-html="$t('modals.ModalFeedback.title')"
			/>
			<div class="flex mt-20 mb-20 mr-8">
				<div class="small-text mr-10 feedback-rate-text">
					{{ $tc('modals.ModalFeedback.leastLikelyText') }}
				</div>
				<div v-for="rate in rates" :key="rate.id" class="rate-item">
					<input :id="rate.id" v-model="feedbackData.rate" :value="rate.title" type="radio">
					<label class="rate-item-label pointer" :for="rate.id">{{ rate.title }}</label>
				</div>
				<div class="small-text ml-20 feedback-rate-text">
					{{ $tc('modals.ModalFeedback.mostLikelyText') }}
				</div>
			</div>
			<transition name="popup" mode="out-in" appear>
				<div v-if="feedbackData.rate" class="mt-10">
					<textarea
						v-model="feedbackData.comment"
						class="comment-container"
						:placeholder="$tc('labels.addCommentPlaceholder')"
						style="resize: none;"
						maxlength="140"
					/>
				</div>
			</transition>
			<button
				class="button-light-blue font-uppercase font-regular mt-20"
				style="padding: 10px 48px;"
				:disabled="!feedbackData.rate"
				@click="onConfirm(feedbackData)"
			>
				{{ $tc('modals.ModalFeedback.sendFeedbackText') }}
			</button>
		</div>
	</div>
</template>

<script>
import { ModalMixin } from '~/assets/vue/mixins'

export default {
	name: 'ModalFeedback',
	mixins: [ModalMixin],
	data () {
		return {
			rates:
			[
				{ id: 'one', title: 1 },
				{ id: 'two', title: 2 },
				{ id: 'three', title: 3 },
				{ id: 'four', title: 4 },
				{ id: 'five', title: 5 }
			],
			feedbackData: {
				rate: null,
				comment: ''
			}
		}
	}
}
</script>

<style lang="scss">
.modal-overlay {
	backdrop-filter: none;
	transition: 0.5s ease-in-out;
	.modal-feedback-container {
		position: relative;
		max-width: 422px;
		min-height: 274px;
		width: 100%;
		padding: 30px 30px 20px 30px;
		border-radius: 11px;
		background-color: $white;
		box-shadow: 1px 2px 20px 0 rgba(0, 0, 0, 0.4);
		.close-btn {
			position: absolute;
			top: 18px;
			right: 15px;
			width: 20px;
			height: 20px;
			cursor: pointer;
			background-repeat: no-repeat;
			background-image: url('../../assets/icons/close.svg');
		}
		.rate-item {
			position: relative;
			width: 34px;
			height: 34px;
			margin-right: 3px;
			@-moz-document url-prefix() {
				margin-right: -6px;
			}
			input[type="radio"] {
				cursor: pointer;
				visibility: hidden;
				-moz-appearance: initial;
				position: relative;
				width: 34px;
				height: 34px;
				margin: 0;
				&:after {
					content: '';
					width: 34px;
					height: 34px;
					visibility: visible;
					border-radius: 5px;
					display: inline-block;
					border: 1.5px solid #9e9e9e;
				}
				&:hover:after {
					box-shadow: 0 0 3px 0 rgba(0, 0, 0, 0.33);
				}
				&:checked:after {
					content: '';
					box-shadow: inset 0 1px 3px 0 rgba(0, 0, 0, 0.5);
					border: solid 1px #979797;
					background-color: #eee;
				}
			}
			.rate-item-label {
				position: absolute;
				left: 50%;
				top: 50%;
				transform: translate(-50%,-50%);
			}
		}
		.feedback-rate-text {
			display: flex;
			align-items: center;
			opacity: 0.5;
			letter-spacing: 0.98px;
			font-size: 11px;
		}
		.comment-container {
			resize: none;
			width: 351px;
			height: 51px;
			border-radius: 3px;
			border: solid 1px #c7c7c7;
			padding: 10px 15px;
			&:focus {
				box-shadow: inset 1px 1px 3px 0 rgba(0, 0, 0, 0.19);
				background-color: #f9f9f9;
				outline: none;
			}
		}
	}
}
</style>
